import { Button, IconWarning, Text, csx } from '@vtex/admin-ui'
import React from 'react'
import { FormattedMessage } from 'react-intl'

export interface PaymentAppCancelProps {
  onCancel: () => void
  onGiveUp: () => void
}
const OrderCancelModal = ({
  onCancel: handleCancel,
  onGiveUp: handleGiveUp,
}: PaymentAppCancelProps) => {
  return (
    <div
      className={csx({
        paddingTop: '$space-8',
        paddingBottom: '$space-4',
        paddingX: '$space-4',
      })}
    >
      <div
        className={csx({
          display: 'flex',
          justifyContent: 'center',
          flexDirection: 'column',
          alignItems: 'center',
          paddingX: '$space-8',
          width: 'full',
        })}
      >
        <IconWarning
          weight="fill"
          className={csx({
            color: '$warning',
            height: '50px',
            width: '50px',
          })}
        />
        <Text
          variant="title1"
          className={csx({
            textAlign: 'center',
            marginTop: '$space-6',
            fontSize: '1.25rem',
          })}
        >
          <FormattedMessage id="placeorder.modal.cancel.title" />
        </Text>
        <Text className={csx({ textAlign: 'center', marginTop: '$space-5' })}>
          <FormattedMessage id="placeorder.modal.cancel.description" />
        </Text>
      </div>
      <div
        className={csx({
          display: 'flex',
          flexDirection: 'column',
          marginTop: '$space-6',
        })}
      >
        <Button
          data-cy="dismiss-payment-app"
          className={csx({ height: '48px' })}
          variant="primary"
          onClick={handleCancel}
        >
          <Text variant="title1" className={csx({ color: 'white' })}>
            <FormattedMessage id="placeorder.modal.cancel.button.cancel" />
          </Text>
        </Button>
        <Button
          className={csx({ height: '48px', marginTop: '$space-3' })}
          variant="tertiary"
          onClick={handleGiveUp}
        >
          <Text variant="title1" className={csx({ color: '$action.primary' })}>
            <FormattedMessage id="placeorder.modal.cancel.button.giveUp" />
          </Text>
        </Button>
      </div>
    </div>
  )
}

export default OrderCancelModal
